import { graphql, navigate, useStaticQuery } from "gatsby";
import { ReactElement, useEffect, useState } from "react";
import { useDependency } from "../../../../contexts/DependencyContext";
import { DownloadsService } from "../../../../services/http/DownloadsService";
import { downloadBlueArrow } from "../../../Icons";
import * as styles from "./Activation.module.scss";

interface IActivation {
    widgetProps: GatsbyTypes.strapi_ComponentDownloadActivation[];
    id: number;
}

export default function Activation({ widgetProps, id }: IActivation): ReactElement {
    const [activation, setActivation] = useState(widgetProps);
    const [visible, setVisible] = useState(true);
    const downloadsService = useDependency(DownloadsService);
    const text = useStaticQuery<GatsbyTypes.Query>(query);

    useEffect(() => {
        setActivation(widgetProps && widgetProps.slice(0, 3));
        if (widgetProps && widgetProps.length < 4) setVisible(false);
    }, []);

    async function getAllActivation() {
        const allActivation = await downloadsService.getAllActivationAsync(id);
        setActivation(allActivation);
        setVisible(false);
    }

    return (
        <>
            <div className="mainBox">
                <div className={styles.activationContainer}>
                    {activation &&
                        activation.map(x => (
                            <div className={styles.activationGrid} key={x.id}>
                                <div className={styles.cardTitle}>{x.base?.heading}</div>
                                <div className={styles.bottomContainer}>
                                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: x.base?.paragraph ?? "" }} />
                                    {((x.linkFile && x.linkFile.length > 0) || (x.file && x.file.url)) && (
                                        <div className={styles.buttonContainer} onClick={async () => await navigate(x.linkFile && x.linkFile.length > 0 ? x.linkFile : x.file?.url ?? "")}>
                                            <div>
                                                <div className={styles.versionText}>Version {x.version}</div>
                                            </div>
                                            <div>{downloadBlueArrow}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                </div>
                {visible && (
                    <div className={styles.showMoreButtonContainer}>
                        <button className={styles.showMoreButton} onClick={getAllActivation}>
                            {text.strapi.downloadGridText?.btnShowMoreText}
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}

const query = graphql`
    query {
        strapi {
            downloadGridText {
                btnShowMoreText
                activation {
                    mainTitle
                }
            }
        }
    }
`;
